import { STORAGE_KEY, TOKEN_KEY } from './config'
import { getItem, getItemObject, removeItem } from './storage'
export function getUserInfo () {
  return getItemObject(STORAGE_KEY)
}  
export function clearUserInfo () {
  return removeItem(STORAGE_KEY)
}
export function getUserToken() {
  return getItem(TOKEN_KEY)
}